import { render, staticRenderFns } from "./app-form.vue?vue&type=template&id=5d288006&"
import script from "./app-form.vue?vue&type=script&lang=js&"
export * from "./app-form.vue?vue&type=script&lang=js&"
import style0 from "./app-form.vue?vue&type=style&index=0&id=5d288006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports